import * as React from 'react';
import SearchCheckForm from './SearchCheckForm';

const LoadingCashierCheck = () => (
  <div className="page">
    <div className="page-title">
      <h1>Поиск чека</h1>
    </div>
    <SearchCheckForm />
  </div>
);

export default LoadingCashierCheck;
